package com.essntl.features.invoice.ui.addeditinvoice.components.sidebar

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import com.essntl.core.utils.utils.formatIntMoney
import com.essntl.features.invoice.ui.addeditinvoice.components.ExpandCollapseArrowWithText
import com.essntl.features.invoice.ui.addeditinvoice.price.sumOfPrice
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun InvoicingPriceDetails(
    title: String,
    priceDetailsList: List<PriceDetailsUiState>,
    modifier: Modifier = Modifier,
) {
    var isExpanded by remember { mutableStateOf(true) }

    val priceSum = remember(priceDetailsList) {
        priceDetailsList.sumOfPrice()
    }

    Column(
        modifier = modifier
            .fillMaxWidth(),
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth(),
        ) {
            Text(
                text = title,
                style = MaterialTheme.esTypography.p1Bold16,
                color = MaterialTheme.esColorScheme.textPrimary,
            )

            Spacer(modifier = Modifier.weight(1f))

            ExpandCollapseArrowWithText(
                text = "$${formatIntMoney(priceSum)}",
                isExpanded = isExpanded,
                onToggleExpanded = {
                    isExpanded = !isExpanded
                },
            )
        }

        AnimatedVisibility(
            visible = isExpanded,
        ) {
            Column(
                verticalArrangement = Arrangement.spacedBy(1.spacing),
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 1.spacing),
            ) {
                if (priceDetailsList.isEmpty())
                    Text(
                        text = "No ${title.lowercase()} selected",
                        style = MaterialTheme.esTypography.p1Regular16,
                        color = MaterialTheme.esColorScheme.textSecondary,
                    )

                priceDetailsList.forEach { state ->
                    PriceDetailsItem(
                        state = state,
                        modifier = Modifier.fillMaxWidth(),
                    )
                }
            }
        }
    }
}